import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});

export default {
    name: 'modal-approvisionner',
    components: {
        ValidationProvider, ValidationObserver,
    },
    props: {
        user_info: Object,
        compte_id: Number,
        solde_courant_compte_depot: Number,
    },

    data() {
        return {
            provision: {
                source: '',
                montant: '',
                motif: '',
                preuve: ''
            },
            source: '',
            files: [],
            preuve_is_empty: false,
            can_see_proof: true,

            save_loading: false,
            solde_is_less: false,
        }
    },

    watch: {
        source() {
            if (this.source.designation_source == "Compte de dépôt") {
                this.can_see_proof = false
            } else {
                this.can_see_proof = true
            }
            this.solde_is_less = false
        }
    },

    computed: {
        liste_source_approvisionnement() {
            return this.$store.getters['liste_source_approvisionnement']
        },

        
    },

    mounted() {
        this.$store.dispatch('getListeSourceApprovisionnement')
    },

    methods: {
        async save() {
            const isValid = await this.$refs.provision_form.validate();
            if (!isValid) {
                return;
            }

            if (this.can_see_proof) {
                if (this.provision.preuve == '') {
                    this.preuve_is_empty = true
                    return;
                }
            }

            if (this.source.designation_source == "Compte de dépôt") {
                if (this.provision.montant > this.solde_courant_compte_depot) {
                    this.solde_is_less = true
                    return;
                }
            }
            
            this.save_loading = true

            var data = {
                nom_caissier: this.user_info.name,
                titre: this.user_info.titre,
                user_id: this.user_info.id,
                compte_id: 9,           // COmpte de dépense
                source: this.source.id,
                montant: this.provision.montant,
                motif: this.provision.motif,
                preuve: this.provision.preuve
            }


            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.$store.dispatch('saveProvision', form_data).then((response) => {
                if (response.success) {
                    this.provision = {
                        source: '',
                        montant: '',
                        motif: '',
                        preuve: ''
                    }
                    this.source = ''
                    this.files = []
                    this.$refs.provision_form.reset()
                    this.$refs.close_provision.click()

                    this.$emit('updateProvision')

                    this.successToast("Approvisionement effectué avec succès")
                } else {
                    if (response.code == 501) {
                        this.warningToast("Une erreur s'est produite lors de l'enregistrement !")
                    }
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.warningToast("Une erreur s'est produite lors de l'enregistrement !")
            })

        },

        handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.provision.preuve = this.files[0];
		},

        clearError() {
            this.preuve_is_empty = false
            this.solde_is_less = false
		}
    }
}


